module.exports = __webpack_public_path__ + "static/media/Jaipur architecture fest 2019 award 1 2.1.ff10ed87.png";